@if (isGratuityOnly) {
  <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-md-center p-4">
    <img
      class="agent"
      [src]="salesAgent?.picture || 'assets/icons/avatar.svg'"
      alt="agent"
      width="280"
      height="280"
    />

    <div class="mt-6 mt-md-0 ml-md-8">
      <h2 class="semi-bold">Thank you</h2>

      <p class="mt-2">Your gratuity payment has been submitted. We appreciate the gesture!</p>
    </div>
  </div>
} @else {
  <div class="d-flex flex-column align-items-center card">
    <img src="assets/icons/done.svg" alt="done" width="48" height="48" />

    <h2 class="semi-bold mt-6 text-align-center">You're all set with extra protection</h2>

    <p class="mt-3 text-align-center">
      Your protection has been added to the booking. If you have any questions or need<br />help
      later on &mdash; we're just a message away. Safe trip and happy travels!
    </p>
  </div>
}
